import { TtvOpeningCardFrame } from "@/app/(application)/(ttv)/ttv/components/ttvApplication/controls/opening/TtvOpeningCardFrame";

export function TtvEditorLoading() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex h-full min-h-0 flex-1 items-center justify-center bg-ttvGround p-4"
    >
      <TtvOpeningCardFrame
        name="Text to Vocals"
        coverSeed={null}
        status="Opening Text to Vocals…"
      />
    </div>
  );
}
